import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

/**
 * Rebound Net marker fragment for Indoor Football.
 * This indicates the ball hit the rebound net and stayed in play.
 * This is a marker fragment - the actual fielding/catch details come from subsequent fragments.
 */
export default class ReboundNet extends Fragment {
    constructor() {
        super();
        this.code = "RBN";
    }

    summarize() {
        return new FragmentSummary("hit rebound net");
    }

    updateSummaryContext() {
        // No context updates needed - just a marker
    }

    toJSON() {
        return {
            ...super.toJSON()
        };
    }
}
